import { render, staticRenderFns } from "./LogoutVue.vue?vue&type=template&id=276ac57b"
import script from "./LogoutVue.vue?vue&type=script&lang=js"
export * from "./LogoutVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports